var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 11.4688L13.4688 5.5C13.75 5.1875 14.2188 5.1875 14.5312 5.5C14.8125 5.78125 14.8125 6.25 14.5312 6.53125L9.03125 12L14.5 17.5C14.8125 17.7812 14.8125 18.25 14.5 18.5312C14.2188 18.8438 13.75 18.8438 13.4688 18.5312L7.46875 12.5312C7.15625 12.25 7.15625 11.7812 7.46875 11.4688Z",
    fill: "#323233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/_left-arrow.c7acad1b915f647df4ca20ba88f00a80.svg";
export { ForwardRef as ReactComponent };